import { forwardRef } from "react";

import type { CSSProperties } from "react";

/**
 * Campo trampa para robots: un input que una persona no ve ni alcanza con el teclado, pero que
 * un script que completa "todos los campos" llena. Su valor viaja como `clientSignals.honeypot`
 * (ver `useFormSignals`) y la API frena el pedido si llega con algo.
 *
 * - Fuera de la pantalla y no `display: none`: muchos scripts saltean los campos ocultos así.
 * - `aria-hidden` + `tabIndex={-1}`: un lector de pantalla o el Tab nunca llegan.
 * - Nombre sin sentido (`acd_hp`) y `autoComplete="off"`: un nombre tentador ("email",
 *   "website") haría que el autocompletar del navegador lo llene y bloquearía a gente real. Los
 *   `data-*` son para que los gestores de contraseñas (1Password, LastPass, Dashlane) lo ignoren.
 */

const OFFSCREEN: CSSProperties = {
  position: "absolute",
  left: "-10000px",
  top: "auto",
  width: 1,
  height: 1,
  overflow: "hidden",
  opacity: 0,
  pointerEvents: "none",
};

export const BotTrap = forwardRef<HTMLInputElement>(function BotTrap(_props, ref) {
  return (
    <div aria-hidden="true" style={OFFSCREEN}>
      <input
        ref={ref}
        type="text"
        name="acd_hp"
        tabIndex={-1}
        autoComplete="off"
        defaultValue=""
        data-1p-ignore=""
        data-lpignore="true"
        data-form-type="other"
      />
    </div>
  );
});
